<template>
	<div id="quote-checkout-template">
		<div class="container">

            <div class="error" v-if="badId">
                <h1>Error</h1>
                <p>{{badIdMessage}}</p>
            </div>
            <div v-if="survey">
                <div class="col md-12 header">
                    <h1>Your Quote has Arrived!</h1>
                </div>

                <div class="row">
                    <div class="col md-8 area-posts">
                        <div class="area-post col md-12" v-for="(area, index) in survey.areas" :key="area.areaId">
                            <div class="areas__count">{{index+1}}of{{survey.areas.length}}</div>
                            <div class="col md-12 top">
                                
                                <div class="col md-9">
							<div class="area-post__title">{{area.areaTitle | truncate(70)}}</div>
							<div class="area__subtitle">Total Area - <span> {{area.areaSquared.toLocaleString('en')}} sqm</span></div>
						</div>
                        <div class="col md-3 area-post__id">Area ID - {{area.areaId}}</div>
                            </div>
                            <div class="col md-12">
                                <table class="area-post__meta">
                                    <thead>
							<tr>
								<th>Land</th>
								<th>Building</th>
								<th>Drone</th>
								<th>Utilities</th>
								<th>File Upload</th>
								<th>Additional Details</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>{{area.serviceOption1 === true ? 'Yes' : 'No'}}</td>
								<td>{{area.serviceOption2 === true ? 'Yes' : 'No'}}</td>
								<td>{{area.serviceOption3 === true ? 'Yes' : 'No'}}</td>
								<td>{{area.serviceOption4 === true ? 'Yes' : 'No'}}</td>
								<td>{{area.userUpload === true ? 'No' : 'Plan uploaded'}}</td>
								<td>{{area.additionalDetails[0] == "" ? 'None' : 'Yes'}}
								</td>
							</tr>
						</tbody>
                                </table>
                            </div>
                        </div>

                        <div class="quote-checkout__lower">
                            <div class="col md-6 quote-summary__user-meta">
                                <div class="box account-info">
                                    <div class="box-panel box-header">
                                        Account Information
                                    </div>
                                    <div class="box-panel box-content" v-if="userInfo">
                                        <ul class="box__user-info">
                                            <li class="email">{{userInfo.email}}</li>
                                            <li class="primary-phone">{{userInfo.phoneNumber}}</li>
                                            <li class="secondary-phone" v-if="userInfo.phoneNumberTwo">{{userInfo.phoneNumberTwo}}</li>
                                            <div class="address">
                                                <li>{{userInfo.addressLineOne}}</li>
                                                <li>{{userInfo.addressLineTwo}}</li>
                                                <li>{{userInfo.postCode}}</li>
                                                <div class="clearfix"></div>
                                            </div>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="col md-6 access-arrangements">
                                <div class="box">
                                    <div class="box-panel box-header access-arrangements__header">
                                        <div class="access-arrangements__title">
                                            Invoice to Client / Access:
                                       
                                            <input type="checkbox" v-model="accessArrangementsActive">
                                        </div>
                                    </div>
                                    <div class="box-panel box-content" v-if="accessArrangementsActive">
                                        <input 
                                            v-model="accessArrangements.nameOfContact" 
                                            type="text" 
                                            placeholder="Contact Name"
                                        >
                                        <input 
                                            v-model="accessArrangements.companyName" 
                                            type="text" 
                                            placeholder="Company Name"
                                        >
                                        <input 
                                            v-model="accessArrangements.address" 
                                            type="text" 
                                            placeholder="Address"
                                        >
                                        <input 
                                            v-model="accessArrangements.emailAddress" 
                                            type="email" 
                                            placeholder="Email"
                                        >
                                        <input 
                                            v-model="accessArrangements.phoneNumber" 
                                            type="number" 
                                            placeholder="Phone"
                                        >
                                        <input 
                                            v-model="accessArrangements.message" 
                                            type="text" 
                                            placeholder="Access Details"
                                        >
                                        <button class="btn btn-small" @click="saveAccessArrangements">Save</button>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="col md-4">

                        <div class="box survey-info">
                            <div class="box-panel box-header">
                                Survey Information
                            </div>
                            <div class="box-panel box-content">
                                <ul class="box__survey-info">
                                    <li>Quotation Ref <span>{{survey.survey.quoteReference}}</span></li>
                                    <li>Number of Areas <span>{{survey.areas.length}}</span></li>
                                    <li>Total Area <span>{{survey.survey.totalArea | currency('', 0) }}sqm</span></li>
                                </ul>
                            </div>
                        </div>

                        <div class="survey-quote__meta">
                            <div class="survey-quote__meta--price" v-if="survey">
                                <div class="col md-7 survey-quote__meta__desc">Subtotal</div>
                                <div class="col md-5 survey-quote__meta__val">{{survey.survey.quotePrice | exVAT() | currency('£', 2)}}</div>
                                <div v-if="checkoutBox">
                                     <div class="col md-7 survey-quote__meta__desc">VAT at 20%</div>
                                    <div class="col md-5 survey-quote__meta__val">{{survey.survey.quotePrice | VAT() | currency('£', 2)}}</div>
                                    <div class="col md-7 survey-quote__meta__desc">Total inc VAT</div>
                                    <div class="col md-5 survey-quote__meta__val">{{survey.survey.quotePrice | currency('£', 2)}}</div>
                                    
                                </div>
                                <div class="clearfix"></div>
                            </div>
                            <div class="survey-quote__meta--dl-pdf" v-if="survey">
                                <div class="col md-7 survey-quote__meta__desc">Download Full PDF quotation</div>
                                <div class="col md-5 survey-quote__meta__val">
                                    <a download :href="survey.survey.quotePDFUrl">
                                        <button class="btn dl">Download</button>
                                    </a>
                                </div>
                                <div class="clearfix"></div>
                                <div class="checkout" v-if="checkoutBox" >
                                 <div class="survey-quote__meta__desc stripe-pay-desc">Please enter your card details below</div>
                                 <stripe-elements
                                    ref="elementsRef"
                                    :pk="publishableKey"
                                    locale="en-GB"
                                    @token="tokenCreated"
                                    @loading="loading = $event"
                                    :receipt_email="true"
                                >
                                </stripe-elements>
                                <button class="btn stripe-btn" @click="submit">Submit Payment {{survey.survey.quotePrice | currency('£', 2)}}</button>
                            </div>
                            </div>
                        </div>

                        <div class="make-payment">
                            <div v-if="checkoutBox === false">
                            <div class="mp__or">OR</div>
                            <div class="col md-6 make-payment-box">
                                <button class="btn make-payment__pay-now" @click="togglePayNowModal">
                                    Confirm &amp; Pay</br>
                                </button>
                            </div>
                            <div class="col md-6 make-payment-box-l">
                                <button class="btn make-payment__pay-invoice" @click="payByInvoiceModal">
                                    Confirm &amp; Request Credit
                                </button>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        </div>
                        <div class="card-icons">
                            <img src="@/assets/images/card-icons.png" alt="">
                            <p>By confirming, you accept the terms of the quote.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PayNowModal @payByCard="payByCard" @payByBacs="togglePayByBacsModal"/>
        <PayByBacsModal v-if="survey" :quoteReference="survey.survey.quoteReference" @sendBacsPaymentConfirm="payByBacsConfirm"/>
        <confirmPayByInvoice @emitConfirmSendByInvoice="payByInvoice"/>
        
    </div>
    
</template>

<script>
import PayNowModal from '@/components/common/Modals/PayNowModal';
import PayByBacsModal from '@/components/common/Modals/PayByBacsModal';
import confirmPayByInvoice from '@/components/common/Modals/confirmPayByInvoice';
import { StripeElements } from 'vue-stripe-checkout'
import logo from '@/assets/images/company-logo.svg'
export default {
	data(){
		return {
            badId : false,
            badIdMessage : '',
            quoteReference : '',
            accessArrangementsActive : false,
            accessArrangements : {
                nameOfContact : '',
                companyName : '',
                address : '',
                emailAddress : '',
                phoneNumber : '',
                message : ''
            },
            survey : null,
            checkoutBox: false,
            publishableKey: 'pk_live_ItvigY2YMo6b6XfmtI59Wev0',
            image: logo,
            currency: 'GBP',
            panelLabel: 'Pay {{amount}}',
            loading: false,
            token: null,
            charge: null,
		}
    },
	components : {
        PayNowModal,
        PayByBacsModal,
        confirmPayByInvoice,
        StripeElements
    },
    watch : {
        openSurveys : function(newVal, oldVal){
            this.checkAndGetSurvey();
        }
    },
	computed : {
		openSurveys(){
            
            return this.$store.getters.getOpenSurveys
            
        },
        userInfo(){
            
            return this.$store.getters.getUserInfo
            
		},
	},
	methods : {
		checkAndGetSurvey(){
            let quoteId = this.$route.params.id;
            if(!quoteId){
                this.badId = true
                this.badIdMessage = 'No quote reference passed to the url params'
            } else {
                this.badId = false;
                this.quoteReference = quoteId;
            }

            let correctSurvey = this.openSurveys.filter((surveyData) => {
                return surveyData.survey.quoteReference === quoteId
            })
            
            if(correctSurvey.length > 0){
                this.survey = correctSurvey[0];
                this.badId = false;
                this.badIdMessage = ''; 
                if(correctSurvey[0].survey.accessArrangements !== null){
                    this.accessArrangementsActive = true;
                    this.accessArrangements = correctSurvey[0].survey.accessArrangements
                }
            } else {
                this.badId = true
                this.badIdMessage = 'Your quote either does not exist or it is not at the correct stage to take payment.'
            }
        },

        saveAccessArrangements(){
            let accessArrgs = this.accessArrangements;

            if(
                !accessArrgs.nameOfContact &&
                !accessArrgs.companyName && 
                !accessArrgs.address && 
                !accessArrgs.emailAddress && 
                !accessArrgs.phoneNumber &&
                !accessArrgs.message
            ){
                this.$toasted.show("Nothing to save", {
                    theme: 'bubble',
                    position: 'bottom-center',
                    duration: 5000
                })
                return;
            }

            let data = { 
                quoteReference : this.quoteReference,
                data : {
                    accessArrangements : this.accessArrangements
                }
             }
            
           
            this.$store.dispatch('updateSurveyData', data)
            .then((response) => {
            	this.$toasted.clear();
            	if(response.confirmation === 'fail' || response.confirmation === 'validation'){
            		this.$toasted.error(response.message, {
		                theme: 'bubble',
		                position: 'bottom-center',
		                duration: 5000
		            })
		            return;
            	} 

            	if(response.confirmation === 'success'){
            		this.$toasted.success('Your Access arragnements have been saved', {
		                theme: 'bubble',
		                position: 'bottom-center',
		                duration: 5000
		            })
		            return;
            	}
            })
            .catch((err) => {
            	this.$toasted.clear();
            	this.$toasted.error(err.message, {
		            theme: 'bubble',
		            position: 'bottom-center',
		            duration: 5000
		        })
		        return;
            })
        },

        toggleInvoiceSendPurchaseOrderModal(){
            this.$store.commit('openModal', 'InvoiceSendPurchaseOrderModal');
        },

        togglePayNowModal(){
            this.$store.commit('openModal', 'PayNowModal');
        },

        payByInvoiceModal(){
            this.$store.commit('openModal', 'confirmPayByInvoice');
        },

        togglePayByBacsModal(){
            this.$store.commit('openModal', 'PayByBacsModal');
        },

        payByCard(){
            //console.log(this.checkoutBox)
            this.$store.commit('openModal', '');
            this.checkoutBox = true;
            
        },

         submit () {
            this.$refs.elementsRef.submit();
        },

        tokenCreated (token) {
            this.token = token;
            // for additional charge objects go to https://stripe.com/docs/api/charges/object
            console.log(this.survey.survey.quotePrice);
            this.charge = {
            source: token.id,
            name: 'Topographical',
            currency: 'GBP',
            email : this.userInfo.email,
            amount: this.survey.survey.quotePrice * 100,
            description: this.description // optional description that will show up on stripe when looking at payments
            }
            this.sendTokenToServer(this.token);
        },

        sendTokenToServer (token) {
            let vm = this;
                vm.sendPaymentToServer({token : token});
        },   

        payByInvoice(){
            this.sendPaymentToServer({type : 'invoice'});
        },

        payByBacsConfirm(){
            this.sendPaymentToServer({type : 'bacs'});
        },

        sendPaymentToServer(payload){
            
            let data = {}

            if(payload.token){
                data.token = payload.token;
                data.urlParam = 'card'
            } else if (payload.type == 'invoice') {
                data.urlParam = 'invoice'
            } else if (payload.type == 'bacs'){
                data.urlParam = 'bacs'
            }
            data.quoteReference = this.quoteReference
            console.log(data);
            this.$store.dispatch('makeFinalPayment', data)
             .then((response) => {
            	this.$toasted.clear();
            	if(response.confirmation === 'fail' || response.confirmation === 'validation'){
            		this.$toasted.error(response.message, {
		                theme: 'bubble',
		                position: 'bottom-center',
		                duration: 5000
		            })
		            return;
            	} 

            	if(response.confirmation === 'success'){
            		this.$toasted.success(response.message, {
		                theme: 'bubble',
		                position: 'bottom-center',
		                duration: 5000
                    })
                    if(payload.type == 'invoice'){
                         this.$store.commit('openModal', 'InvoiceSendPurchaseOrderModal')
                    }
		            return;
                }
                
               
            })
            .catch((err) => {
            	this.$toasted.clear();
            	this.$toasted.error(err.message, {
		            theme: 'bubble',
		            position: 'bottom-center',
		            duration: 5000
		        })
		        return;
            })
        }
    },
    mounted(){
        this.checkAndGetSurvey()
    }
    
}

</script>



// WEBPACK FOOTER //
// src/components/pages/QuoteCheckout.vue